/*
 * Developed for EPSON AMERICA INC. by Softeq Development Corporation
 * http://www.softeq.com
 */

import React from 'react'
import Reaptcha from 'reaptcha'

class Captcha extends React.Component<any, any> {
  private onChange = value => {
    const { input: { onChange }, verifyCallback } = this.props

    onChange(value)
    verifyCallback(value)
  }

  private onExpire = () => {
    const { input: { onChange }, verifyCallback } = this.props

    onChange(null)
    verifyCallback(null)
  }

  public render () {
    return (
      <Reaptcha
        key={this.props.lang}
        ref={this.props.captchaRef}
        onVerify={this.onChange}
        onExpire={this.onExpire}
        sitekey={this.props.googleRecaptchaSiteKey}
        hl={this.props.lang}
      />
    )
  }
}

export default Captcha
